import { gql } from '@apollo/client'

export const GET_NOTIFICATIONS = gql`
  query ($country: String) {
    getNotifications(country: $country) {
      id
      story_id
      story {
        id
        updated_at
        campaign_id
        campaign {
          id
          name
          owner_id
          unit_id
          label_id
          artist {
            id
            name
            facebook_id
            spotify_id
          }
        }
      }
      product {
        id
        name
        parent_id
        publish_date
        configuration
        campaign {
          id
          name
          label_id
          artist {
            id
            name
          }
        }
      }
      notification_type
      properties {
        gcdm_matches {
          artistDisplayTitle
          gpid_list
          displayTitle
          dv_entity_id
          dv_group_id
        }
      }
    }
  }
`
